import React, { useState, useCallback, useContext } from "react";
import styled from "styled-components";
import EditPic from "../../../SVGs/Edit.svg";
import CustomTextField from "../../Common/CustomTextField";
import CustomRadioButton from "../../Common/CustomRadioButton";
import toast from "react-hot-toast";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import Cookies from "js-cookie";
import { UserContext } from "../../../Context/user_context";
import PageLoader from "../../Common/PageLoader";
import CustomDropDown from "../../Common/CustomDropDown";
import { States } from "../../../utils/States";

function HomeAddress({ data, contactId, showSameAddressCheckbox = true, refetchData, recordType }) {
  const [isLoading, setIsLoading] = useState(false);
  const [homeAddress, setHomeAddress] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [street1, setStreet1] = useState(data ? data.address1_line1 : "");
  const [street2, setStreet2] = useState(data ? data.address1_line2 : "");
  const [city, setCity] = useState(data ? data.address1_city : "");
  const [state, setState] = useState(data ? data.hip_address1_state : "");
  const [zip, setZip] = useState(data ? data.address1_postalcode : "");
  const [moveInDate, setMoveInDate] = useState(data ? data.new_moveindate : "");
  const [sameHomeAddress, setSameHomeAddress] = useState(showSameAddressCheckbox ? data ? data.hip_samehomeaddressasmaincontact === 910310001 ? false : true : false : false);
  const handleContactInformation = useCallback(() => {
    setHomeAddress(!homeAddress);
  }, [homeAddress]);

  const handleUpdateRecord = async () => {
    setIsLoading(true);
    const userid = contactId
      ? contactId
      : Cookies.get("hippocratic_portal_contactid");
    const recordData = {
      entity: "contacts",
      id: userid,
      attributes: [
        {
          fieldname: "address1_line1",
          value: street2,
          type: "string",
          entity: null,
        },
        {
          fieldname: "address1_line2",
          value: street2,
          type: "string",
          entity: null,
        },
        {
          fieldname: "address1_city",
          value: city,
          type: "string",
          entity: null,
        },
        {
          fieldname: "hip_address1_state",
          value: state,
          type: "string",
          entity: null,
        },
        {
          fieldname: "address1_postalcode",
          value: zip,
          type: "string",
          entity: null,
        },
        {
          fieldname: "new_moveindate",
          value: moveInDate,
          type: "string",
          entity: null,
        },
        ...(showSameAddressCheckbox ? [{
          fieldname: "hip_samehomeaddressasmaincontact",
          value: sameHomeAddress ? "910310000" : "910310001",
          type: "optionset",
          entity: null,
        }] : []),
        ...(user.hip_initialportalinfoupdate ? [] : [{
          fieldname: "hip_initialportalinfoupdate",
          value: "910310000",
          type: "optionset",
          entity: null,
        }])
      ],
    };

    try {
      await getApiClient().updateRecord(recordData);
      if (!user.hip_initialportalinfoupdate) {
        setUser({
          ...user,
          hip_initialportalinfoupdate: true
        });
      }
      toast.success("Information has been updated succesfully");
      if (refetchData) {
        await refetchData();
      }
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error(error));
    } finally {
      setIsLoading(false);
      setHomeAddress(!homeAddress);
    }
  };

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Section>
        <TopPart>
          <SubTitle>Home Address</SubTitle>
          {homeAddress ? (
            <Save onClick={handleUpdateRecord}>Save Changes</Save>
          ) : (
            <Edit
              onClick={() => {
                handleContactInformation();
              }}
            >
              Edit
              <img style={{ height: "19px" }} src={EditPic} alt="edit-icon" />
            </Edit>
          )}
        </TopPart>
        <BottomPart>
          {showSameAddressCheckbox && (
            <FieldsContainer>
              <CustomRadioButton
                bold={true}
                Active={homeAddress}
                title={recordType === "Child" ? "Same home address as parent:" : "Same home address as spouse:"}
                options={[true, false]}
                value={sameHomeAddress}
                // selectedValue={sameHomeAddress}
                onChange={setSameHomeAddress}
              />
            </FieldsContainer>
          )}
          {!sameHomeAddress && (
            <>
              <FieldsContainer>
                <CustomTextField
                  Active={homeAddress}
                  Title="Street 1:"
                  value={street1}
                  onChange={setStreet1}
                />
                <CustomTextField
                  Active={homeAddress}
                  Title="Street 2:"
                  value={street2}
                  onChange={setStreet2}
                />
                <CustomTextField
                  Active={homeAddress}
                  Title="City:"
                  value={city}
                  onChange={setCity}
                />
              </FieldsContainer>
              <FieldsContainer>
              <CustomDropDown
                  Active={homeAddress}
                  options={States}
                  Title="State:"
                  value={state}
                  onChange={setState}
                />
                <CustomTextField
                  Active={homeAddress}
                  Title="ZIP Code:"
                  value={zip}
                  onChange={setZip}
                />
                <CustomTextField
                  Active={homeAddress}
                  Title="Move in Date:"
                  value={moveInDate}
                  onChange={setMoveInDate}
                />
              </FieldsContainer>
            </>
          )}
          <FieldsContainer></FieldsContainer>
        </BottomPart>
      </Section>
    </>
  );
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const TopPart = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const Edit = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #87a9bf;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: 10px;
  text-decoration-line: underline;
`;

const BottomPart = styled.div`
  display: grid;
  min-height: 100px;
  gap: 30px;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;

  @media screen and (max-width: 450px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;
const SubTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const FieldsContainer = styled.div`
  display: flex;
  gap: 30px;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const Save = styled.div`
  border-radius: 300px;
  background: #304961;
  padding: 5px 10px;

  cursor: pointer;

  white-space: nowrap;

  color: #fff;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export default HomeAddress;
